type Filter = (args: unknown[]) => boolean // true => suppress

let refCount = 0
let original: typeof console.error | null = null

const defaultFilter: Filter = (args) => {
  const msg = args[0]

  return (
    typeof msg === "string" &&
    (msg.includes("no parser registered") ||
      msg.includes("parsed json with extra tokens"))
  )
}

// Suppress parser noise in the console during typing in CodeEditor.
// There is another way here: https://github.com/jsonnext/codemirror-json-schema/issues/159, but it is still a hack
// and it requires an additional package: @codemirror/autocomplete
export default function consoleErrorFilter(filter: Filter = defaultFilter) {
  refCount++

  if (refCount === 1) {
    original = console.error
    console.error = (...args: unknown[]) => {
      if (filter(args)) {
        return
      }

      if (!original) {
        return
      }

      original(...args)
    }
  }

  // Each caller may only give back what it took: releasing twice would drop
  // the count below what is still owed and un-patch the console for the
  // editors that are still open.
  let released = false

  return () => {
    if (released) {
      return
    }
    released = true

    refCount = Math.max(0, refCount - 1)
    if (refCount === 0 && original) {
      console.error = original
      original = null
    }
  }
}
